// extracted by mini-css-extract-plugin
module.exports = {"errorFallback":"errorBoundary-module--errorFallback--Mcna3"};